import Heading from '../../shared/utils/Heading'
import { Box, Typography } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { Page_Padding } from '../../shared/constants'
import AddSection from '../Home/AddSection'
import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { usePageContentWithMeta } from '../../shared/hook/usePageContentWithMeta'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const AboutUs = ({ onLoadingChange = () => { } }) => {
    const { data: Detail, isLoading: isDetailLoading } = usePageContentWithMeta("ABOUT_US");;
   
    useEffect(() => {
        onLoadingChange(isDetailLoading);
    }, [isDetailLoading, onLoadingChange]);


    const location = useLocation();
    
    useEffect(() => {
        if (location.hash) {
            const id = location.hash.replace("#", "");
            const el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location]);

    if (isDetailLoading) return null;

    return (
        <Box className="body contact_us" px={Page_Padding}>
           
            <Heading
                SubHeading={Detail?.content[0]?.data?.heading}
                Heading={Detail?.content[0]?.data?.subheading}
                mb={"1rem"}
            />
           
        <Typography variant="body1" color='grey.400' mb={3} dangerouslySetInnerHTML={{ __html: Detail?.content[0]?.data?.description }} />
           
            <AddSection
                bgimg={Detail?.content[1]?.data?.imageUrl}
                title={Detail?.content[1]?.data?.heading}
                subTitle={Detail?.content[1]?.data?.subheading}
                description={Detail?.content[1]?.data?.description}
                buttonText={Detail?.content[1]?.data?.buttonText} />
            
            <CustomDivider />
            
            <div id='vision'>
                <Heading
                    SubHeading={Detail?.content[2]?.data?.heading}
                    Heading={Detail?.content[2]?.data?.subheading}
                    mb={"1rem"}
                />
                <Typography variant="body1" color='grey.400' mb={3} dangerouslySetInnerHTML={{ __html: Detail?.content[2]?.data?.description }} />
                <Box
                    component={"img"}
                    // src={Constants.customImages.AboutUsFrame2}
                    src={getImageUrl(Detail?.content[3]?.data?.imageUrl)}
                    sx={{
                        width: { xs: "100%", sm: "90%", md: "60%" },
                        display: "block",
                        margin: "auto"
                    }}
                />
                <Typography variant="body1" color='grey.400' mb={3} dangerouslySetInnerHTML={{ __html: Detail?.content[4]?.data?.description }} />
            </div>
           
            <CustomDivider />
          
            <Heading
                Heading={Detail?.content[5]?.data?.subheading}
                mb={"1rem"}
            />
           
            <Typography variant="body1" color='grey.400' mb={3} dangerouslySetInnerHTML={{ __html: Detail?.content[5]?.data?.description }} />
           
            <Box
                sx={{ bgcolor: "red" }}
            >
                <Box
                    component={"img"}
                    // src={Constants.customImages.AboutUsFrame1}
                    src={getImageUrl(Detail?.content[6]?.data?.imageUrl)}

                    sx={{
                        width: { xs: "100%", sm: "90%", md: "60%" },
                        display: "block",
                        margin: "auto",
                        borderRadius: 0
                    }}
                />
            </Box>

            <CustomDivider />

            <div id='team'>
                <Heading
                    Heading={Detail?.content[7]?.data?.subheading}
                    mb={"1rem"}
                />
                <Typography variant="body1" color='grey.400' mb={3} dangerouslySetInnerHTML={{ __html: Detail?.content[7]?.data?.description }} />
            </div>
        </Box>

    )
}

export default AboutUs